import '@/shared/csrf-token-deprecated';

import $ from '@/bundles/jquery';
import SubmitLoading from "@/shared/submit-loading";

// use '@/shared/follow-button' instead
class FollowButtonDeprecated {
    constructor($btn) {
        this.active = false;

        this.$btn = $btn;
        this.$icon = $btn.find('.icon');
        this.$text = $btn.find('.text');

        this.userId = $btn.data('user');

        this.init();
    }

    init() {
        var self = this;

        this.$btn.on('click', function () {
            if (self.$btn.hasClass('loading')) {
                return false;
            }

            if (self.$btn.hasClass('js-login-open')) {
                return false;
            }

            self.request(!self.active);

            /*
            if (isLiked) {
                self.count--;
                self.makeInactive();
            } else {
                self.count++;
                self.makeActive();
            }
             */
        });
    }

    actsAsLoginButton() {
        return this.$btn.hasClass('js-login-open');
    }

    enable() {
        this.$btn.removeClass('disabled btn-default');
        this.$btn.removeAttr('disabled');
        this.$btn.addClass('btn-secondary');
    }

    disable() {
        this.$btn.removeClass('btn-secondary');
        this.$btn.addClass('disabled btn-default');
        this.$btn.attr('disabled', true);
    }

    makeActive() {
        this.active = true;
        this.$icon.removeClass('fa-plus').addClass('fa-check');
        this.$btn.addClass('active');
        this.$text.text('Following');
    }

    makeInactive() {
        this.active = false;
        this.$icon.removeClass('fa-check').addClass('fa-plus');
        this.$btn.removeClass('active');
        this.$text.text('Follow');
    }

    request(follow) {
        var self = this;

        this.$btn.addClass('loading');
        SubmitLoading.startLoading(this.$btn);

        var url = '/api/v1/users/' + this.userId + (follow ? '/follow' : '/unfollow')

        $.ajaxCsrf(url, {
            method: "post",
        }).then(function (result) {
            if (result.data.following) {
                self.makeActive();
            } else {
                self.makeInactive();
            }
        }).always(function () {
            SubmitLoading.finishLoading(self.$btn);
            self.$btn.removeClass('loading');
        });
    }
}

export default FollowButtonDeprecated;
